import { render, staticRenderFns } from "./Breadcrumps.vue?vue&type=template&id=321a863b&"
import script from "./Breadcrumps.vue?vue&type=script&lang=js&"
export * from "./Breadcrumps.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports